import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';

import { ReactComponent as IconPen } from '../../../../../../../../assets/img/icn-pen2.svg';

const InlineVinEdit = ({ vin, onSave }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(vin || '');
  const [isSaving, setIsSaving] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleSave = () => {
    setIsSaving(true);
    setErrorMessage(null);
    onSave(
      { vin: value },
      () => {
        setIsSaving(false);
        setIsEditing(false);
      },
      (error) => {
        setIsSaving(false);
        setErrorMessage(error);
      },
    );
  };

  const handleCancel = () => {
    setValue(vin || '');
    setErrorMessage(null);
    setIsEditing(false);
  };

  if (isEditing) {
    return (
      <div>
        {errorMessage && (
          <Alert variant="danger" dismissible onClick={() => setErrorMessage(null)} className="p-2 mb-2">
            {errorMessage}
          </Alert>
        )}
        <input
          type="text"
          className="form-control form-control-sm mb-2"
          value={value}
          onChange={({ target }) => setValue(target.value)}
        />
        <div className="d-flex justify-content-end">
          <button
            type="button"
            className="btn btn-sm btn-secondary mr-1"
            onClick={handleCancel}
            disabled={isSaving}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={handleSave}
            disabled={isSaving}
          >
            Save
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex justify-content-between align-items-center">
      <span>VIN: {vin || '-'}</span>
      <IconPen
        role="button"
        className="svg-md"
        style={{ cursor: 'pointer' }}
        onClick={() => setIsEditing(true)}
      />
    </div>
  );
};

InlineVinEdit.propTypes = {
  vin: PropTypes.string,
  onSave: PropTypes.func.isRequired,
};

export default InlineVinEdit;
